import { render, staticRenderFns } from "./ClassicUi.vue?vue&type=template&id=26607020&scoped=true&"
import script from "./ClassicUi.vue?vue&type=script&lang=js&"
export * from "./ClassicUi.vue?vue&type=script&lang=js&"
import style0 from "./ClassicUi.vue?vue&type=style&index=0&id=26607020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26607020",
  null
  
)

export default component.exports